import bwmodel from '@/config/bwmodel';
// import  { Base64 }  from 'js-base64/base64.js';
import bridge from '@/config/JSbridge';
import { uploadTrace } from './api';

export const roleInfo = {
  founder: '落魄的创业者',
  fund_manager: '失业的基金经理',
  shareholder: '爱美食的股民',
  speculator: '破产的投机客'
}

export const getStockStr = (incomeDetail = {}) => {
  const {
    halfYearIncomeRatio,
    income,
    incomeRatio,
    month,
    stockName,
  } = incomeDetail;
  const monthStr = `${month}`.slice(4, 6);
  const realMonth = monthStr ? Number(monthStr) + 1 : 1;
  const rise = Number(incomeRatio * 100).toFixed(2);
  const profit = income;
  switch (realMonth) {
    case 1: {
      return `
        <div class='monitor-text'>2023新年伊始，因爆仓而负债累累的你，登上了寒风呼啸的天台。</div>
        <div class='monitor-text'>骤然！天空中冬雷炸响，你的眼前闪过一道白光，只觉一阵天旋地转……</div>
        <div class='monitor-text'>你！穿越到了1年前——2022年1月1日！</div>
        <div class='monitor-text'>能够预知未来的你，誓要将失去的一切悉数赢回！</div>
      `;
    }
    case 2: {
      return `
        <div class='monitor-text'>${stockName}1月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>这时，你突然听到屋外有人在砸门。</div>
        <div class='monitor-text'>“还钱！还钱！”</div>
        <div class='monitor-text'>得知你赚到钱，催收公司立刻追上门来讨债。</div>
        <div class='monitor-text'>你无奈逃走，东躲西藏，暗自咬牙。</div>
        <div class='monitor-text'>只要1年，你会让他们见识到复利究竟有多强大！</div>
      `;
    }
    case 3: {
      return `
        <div class='monitor-text'>${stockName}2月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>俄乌冲突对股市的影响，于你毫无意义！</div>
        <div class='monitor-text'>你的总资产正在指数级的增长！</div>
      `;
    }
    case 4: {
      return `
        <div class='monitor-text'>${stockName}3月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>沪指自3290点一路跌到2863点，股民哀嚎遍地。</div>
        <div class='monitor-text'>但你无所畏惧，因为穿越而来的你知道，黄金大底已现！</div>
      `;
    }
    case 5: {
      return `
        <div class='monitor-text'>${stockName}4月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>首架C919国产大飞机即将交付，而你的账户也正在腾飞。</div>
        <div class='monitor-text'>猩红的数字，扫平了所有人对你的质疑！</div>
        <div class='monitor-text'>渐渐有人开始分析你的操作逻辑，但都不了了之。</div>
      `;
    }
    case 6: {
      return `
        <div class='monitor-text'>${stockName}5月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>新闻里东方甄选火爆出圈，新东方在线股价暴涨近10倍。</div>
        <div class='monitor-text'>但区区10倍，根本不是你的目标。</div>
      `;
    }
    case 7: {
      const halfYearProfitRatio = Number(halfYearIncomeRatio * 100).toFixed(2);
      return `
        <div class='monitor-text'>${stockName}6月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>半年过去，账户中膨胀的数字告诉你，你早已摆脱了当初的窘境。</div>
        <div class='monitor-text'>上半年，你共赚取到了${halfYearProfitRatio}%的收益，是你曾经想都不敢想的数字！</div>
        <div class='monitor-text'>你把收益分享到了市值风云社区，300个前台向你暗送秋波！</div>
        <div class='monitor-text'>但你知道，复利的游戏，最刺激的时刻才刚刚开始……</div>
      `;
    }
    case 8: {
      return `
        <div class='monitor-text'>${stockName}7月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>数家基金公司正在打探你的消息，你嗤之以鼻；</div>
        <div class='monitor-text'>散户们疯狂向你私信，你置之不理；</div>
        <div class='monitor-text'>你毫无规律的操作让所有的分析师抓耳挠腮；</div>
      `;
    }
    case 9: {
      return `
        <div class='monitor-text'>${stockName}8月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>沪指年内再度暴跌，逼近3000点。</div>
        <div class='monitor-text'>满屏的绿色并不能阻止你账户的增长；</div>
        <div class='monitor-text'>火遍全网的《羊了个羊》也比不过你躺着赚钱的速度；</div>
      `;
    }
    case 10: {
      return `
        <div class='monitor-text'>${stockName}9月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>外卖APP再也不给你发放优惠券；</div>
        <div class='monitor-text'>一百多家券商纷纷向你抛出橄榄枝；</div>
        <div class='monitor-text'>宁波敢死队想认你为新的总舵主；</div>
        <div class='monitor-text'>你宠辱不惊，准备迎接最后一个季度的冲刺。</div>
      `;
    }
    case 11: {
      return `
        <div class='monitor-text'>${stockName}10月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>你已成为家喻户晓的股市富豪；</div>
        <div class='monitor-text'>大数据广告开始为你推送豪宅和游艇；</div>
        <div class='monitor-text'>SpaceX为你发来最新的太空旅行计划；</div>
        <div class='monitor-text'>你躺在世界杯赛场的贵宾包房内，枯燥地打开市值风云炒股；</div>
      `;
    }
    case 12: {
      return `
        <div class='monitor-text'>${stockName}11月暴涨 ${rise}%，你净赚${profit}元！</div>
        <div class='monitor-text'>10万本金炒股，能赚多少钱？</div>
        <div class='monitor-text'>你就是这个问题的答案。</div>
        <div class='monitor-text'>时间再次来到冬天，2022年的最后一个月，</div>
        <div class='monitor-text'>你将为自己传奇的炒股经历，画上句号。</div>
      `;
    }
    default: return ''
  }
}

export const openApp = (schema) => {
  // if (bwmodel.app === 'weibo' || (bwmodel.app === 'dingtalk' && bwmodel.system === 'Android')) {
  //   // 
  // } else 
  // let schemeUrl = encodeURIComponent('storm://app/webview?url=' + Base64.encode(url))
  let schemeUrl = encodeURIComponent(schema)
  let universalUrl = schema
  if (bwmodel.system === 'iPhone') {
    const href = process.env.REACT_APP_appOpenUrl + universalUrl
    window.location.href = href
  } else {
    const href = process.env.downloadUrl + '?ios_scheme=' + schemeUrl + '&android_scheme=' + schemeUrl
    window.location.href = href
  }
}

export const activityShare = (callback) => {
  bridge.callHandler('nativeEvent', {
    event: 'shareLink',
    params: {
      title: `牛回！速来股神模拟器！`,
      desc: '假如2022重来，试试你炒股能赚多少钱',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo7.png',
      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_30',
    },
  }, () => {
    callback && callback();
  })
}

export const activityShareFriend = (income, callback) => {
  bridge.callHandler('nativeEvent', {
    event: 'shareLink',
    params: {
      title: `我全年收益${income}，你呢？`,
      desc: '假如2022重来，试试你炒股能赚多少钱',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo7.png',
      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_30',
    },
  }, () => {
    callback && callback();
  })
}

export const isStorm = bwmodel.app === 'storm';


export function convertCanvasToImg(base64) {
  const myBlob = dataURLtoBlob(base64);
  const myUrl = URL.createObjectURL(myBlob);
  downImg(myUrl);
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function downImg(url) {
  let a = document.createElement('a');
  let clickEvent = document.createEvent('MouseEvents');
  a.setAttribute('href', url);
  a.setAttribute('download', 'codeImg');
  a.setAttribute('target', '_blank');
  clickEvent.initEvent('click', true, true);
  a.dispatchEvent(clickEvent);
}

export function getIncomeSplit(income) {
  console.log(income, 'income');
  // debugger
  if (!income) {
    return income;
  }
  
  const [incomeStr, sufix] = `${income}`.split('.');

  const nextIncome = [...incomeStr.split('')].reverse().join('');
  const nextIncomeArr = [];
  nextIncomeArr.push(nextIncome.slice(0, 3))
  nextIncomeArr.push(nextIncome.slice(3, 6))
  nextIncomeArr.push(nextIncome.slice(6, 9))
  nextIncomeArr.push(nextIncome.slice(9, 12))
  nextIncomeArr.push(nextIncome.slice(12, 15))
  nextIncomeArr.push(nextIncome.slice(15, 18));
  const finalNum = nextIncomeArr.filter(item => !!item).join(',').split('').reverse().join('');
  return finalNum + (sufix ? `.${sufix}` : '');
}

export const handleUploadTrace = (id, type, args = {}) => {
  const timestamp = `${new Date().valueOf()}`;
  const event = {
    source: isStorm ? 'inside' : 'outside',
    event: type || 'click',
    eventTime: timestamp,
    type: id
  }
  uploadTrace({
    traceStat: JSON.stringify([event]),
    timestamp: timestamp,
    nonce: id
  })
}


// WEBPACK FOOTER //
// ./src/views/activity_30/stock.js